import { render, staticRenderFns } from "./TestAll.vue?vue&type=template&id=9a27796a&scoped=true&"
import script from "./TestAll.vue?vue&type=script&lang=js&"
export * from "./TestAll.vue?vue&type=script&lang=js&"
import style0 from "./TestAll.vue?vue&type=style&index=0&id=9a27796a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a27796a",
  null
  
)

export default component.exports